import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { convertRole } from '../../lib/tools';
import UserIcon from '../Parts/UserIcon';
import {
  Main,
  UserInfoBoxWrapper,
  UserInfoBox,
  UserInfoDataMain,
  UserInfoData,
  UserInfoData2,
  UserInfoDataName,
  UserInfoTitle,
  Contents,
  ContentsHeader,
  ContentsData,
} from './styles/UserInfoStyles';

const userInfoData = userInfo => {
  const { name, iconUrl, userId, companyCode, role } = userInfo;
  const roleName = convertRole(role);
  return (
    <UserInfoDataMain>
      <UserInfoData>
        <UserIcon size={60} url={iconUrl} />
        <UserInfoDataName>{name}</UserInfoDataName>
      </UserInfoData>
      <UserInfoTitle>
        <FormattedMessage id="userInfo.title" />
      </UserInfoTitle>
      <UserInfoData2>
        <Contents>
          <ContentsHeader>
            <FormattedMessage id="userInfo.userInfo.title.companyCode" />
          </ContentsHeader>
          <ContentsData>{companyCode}</ContentsData>
        </Contents>
        <Contents>
          <ContentsHeader>
            <FormattedMessage id="userInfo.userInfo.title.userId" />
          </ContentsHeader>
          <ContentsData>{userId}</ContentsData>
        </Contents>
        <Contents>
          <ContentsHeader>
            <FormattedMessage id="userInfo.userInfo.title.role" />
          </ContentsHeader>
          <ContentsData>{roleName}</ContentsData>
        </Contents>
      </UserInfoData2>
    </UserInfoDataMain>
  );
};

const UserInfo = ({ userInfo, openUserInfo, onClose }) => (
  <Main id="openUserInfoButton" role="presentation" onClick={() => onClose()}>
    {openUserInfo && (
      <UserInfoBoxWrapper>
        <UserInfoBox>{userInfoData(userInfo)}</UserInfoBox>
      </UserInfoBoxWrapper>
    )}
  </Main>
);

UserInfo.propTypes = {
  onClose: PropTypes.func.isRequired,
  openUserInfo: PropTypes.bool.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default UserInfo;
